import styled from "styled-components";

const BuyStyle = styled.button`
background-color: #FF4500;
border: none;
color: #E6E6FA;
text-align: center;
text-decoration: none;
display: inline-block;
font-size: 14px;
width: 90px;
height: 50px;
border-radius: 2px;
cursor:pointer;
`;


export default BuyStyle;
